const translations = {
    copyright: 'Copyright © {{year}} by AcreConnect',
    termsOfService: 'Privacy Policy and Terms of Service'
};

export default translations;
